import { render, staticRenderFns } from "./EditarDependente.vue?vue&type=template&id=5cfd0d9a&"
import script from "./EditarDependente.vue?vue&type=script&lang=js&"
export * from "./EditarDependente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports